"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _NavigateBackButton = require("@ccw-pwa-ui/NavigateBackButton");
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
require("../../styles/ServiceLogsComponent.scss");
var _StoreInformationTile = require("@ccw-pwa-ui/StoreInformationTile");
var _Button = require("@ccw-pwa-ui/Button");
var _ConnectionLoader = require("@ccw-pwa-ui/ConnectionLoader");
var _strings = require("../../common_features/utility/strings");
var _helper = require("../../common_features/utility/helper");
var _images = _interopRequireWildcard(require("../../common_features/assets/images"));
var _Modal = _interopRequireDefault(require("@ccw-pwa-ui/Modal/lib/Modal"));
var _reactDatepicker = _interopRequireDefault(require("react-datepicker"));
var _Checkbox = require("@ccw-pwa-ui/Checkbox");
var _material = require("@mui/material");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const _ = require("underscore");
const ServiceLogsComponent = _ref => {
  var _Object$keys;
  let {
    navHeading,
    handleBack,
    onClickCancel,
    leftArrow,
    cancelText,
    headerText,
    systemName,
    systemPartNumber,
    listItem,
    arrowIcon,
    operationClicked,
    loadMoreButton,
    loadVisible,
    onClickLoadMore,
    isLoading,
    fetchDate,
    isDesktop,
    handleModal,
    servicesLabel = [],
    checkBoxesLabel,
    modalDropdownData,
    inputLabelFrom,
    inputLabelTo,
    fromValue,
    toValue,
    fromDateFormatted,
    toDateFormatted,
    fromDateChange,
    toDateChange,
    onChangeCheckBox,
    chipContainerLabel,
    selectedChipsList,
    onDeleteChip
  } = _ref;
  return isLoading ? /*#__PURE__*/_react.default.createElement(_ConnectionLoader.ConnectionLoader, null) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_NavigateBackButton.NavigateBackButton, {
    navHeading: navHeading,
    handleBack: handleBack,
    handleCancle: onClickCancel,
    leftArrowImage: leftArrow,
    rightNavHeading: cancelText
  }), (modalDropdownData === null || modalDropdownData === void 0 ? void 0 : modalDropdownData.displayModal) && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Modal.default, {
    displayModal: modalDropdownData === null || modalDropdownData === void 0 ? void 0 : modalDropdownData.displayModal,
    modalHeaderText: modalDropdownData === null || modalDropdownData === void 0 ? void 0 : modalDropdownData.modalHeaderText,
    modalHeaderTextStyle: modalDropdownData === null || modalDropdownData === void 0 ? void 0 : modalDropdownData.modalHeaderTextStyle,
    modalDetailText: modalDropdownData === null || modalDropdownData === void 0 ? void 0 : modalDropdownData.modalDetailText,
    modalHeaderIcon: modalDropdownData === null || modalDropdownData === void 0 ? void 0 : modalDropdownData.modalHeaderIcon,
    displayCrossIcon: modalDropdownData === null || modalDropdownData === void 0 ? void 0 : modalDropdownData.displayCrossIcon,
    variant: modalDropdownData === null || modalDropdownData === void 0 ? void 0 : modalDropdownData.variant,
    positiveActionButtonTitle: !isDesktop && (modalDropdownData === null || modalDropdownData === void 0 ? void 0 : modalDropdownData.positiveActionButtonTitle),
    positiveAction: modalDropdownData === null || modalDropdownData === void 0 ? void 0 : modalDropdownData.positiveAction,
    negativeButtonActionTitle: !isDesktop && (modalDropdownData === null || modalDropdownData === void 0 ? void 0 : modalDropdownData.negativeButtonActionTitle),
    crossIconAction: modalDropdownData === null || modalDropdownData === void 0 ? void 0 : modalDropdownData.crossIconAction,
    negativeAvtion: modalDropdownData === null || modalDropdownData === void 0 ? void 0 : modalDropdownData.negativeAvtion,
    showDateRange: modalDropdownData === null || modalDropdownData === void 0 ? void 0 : modalDropdownData.showDateRange,
    wrapperStyle: modalDropdownData === null || modalDropdownData === void 0 ? void 0 : modalDropdownData.wrapperStyle,
    btn1Style: modalDropdownData === null || modalDropdownData === void 0 ? void 0 : modalDropdownData.btn1Style,
    btn2Style: modalDropdownData === null || modalDropdownData === void 0 ? void 0 : modalDropdownData.btn2Style,
    divStyleBtn1: modalDropdownData === null || modalDropdownData === void 0 ? void 0 : modalDropdownData.divStyleBtn1,
    divStyleBtn2: modalDropdownData === null || modalDropdownData === void 0 ? void 0 : modalDropdownData.divStyleBtn2
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "modal-content-div",
    style: {
      ...(isDesktop && {
        height: window.innerHeight
      })
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "filterTitle-div-style"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "filter-label-div"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "filters-modal-title"
  }, "Filters")), /*#__PURE__*/_react.default.createElement("div", {
    className: "filter-cross-div"
  }, /*#__PURE__*/_react.default.createElement("div", null, isDesktop && /*#__PURE__*/_react.default.createElement("img", {
    onClick: modalDropdownData === null || modalDropdownData === void 0 ? void 0 : modalDropdownData.crossIconAction,
    src: _images.default.CloseIcon.default
  })))), isDesktop && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "buttons-div-style"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "button-style"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    buttonStyle: {
      height: "48px",
      alignItems: "center"
    },
    variant: "outline-primary-long",
    title: modalDropdownData === null || modalDropdownData === void 0 ? void 0 : modalDropdownData.negativeButtonActionTitle,
    onClick: modalDropdownData === null || modalDropdownData === void 0 ? void 0 : modalDropdownData.negativeAvtion
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "button-style"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    buttonStyle: {
      height: "48px",
      alignItems: "center"
    },
    variant: "primary-long",
    title: modalDropdownData === null || modalDropdownData === void 0 ? void 0 : modalDropdownData.positiveActionButtonTitle,
    onClick: modalDropdownData === null || modalDropdownData === void 0 ? void 0 : modalDropdownData.positiveAction
  }))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginLeft: "20px"
    },
    className: "label-style-service-logs"
  }, "Date Range"), /*#__PURE__*/_react.default.createElement("div", {
    className: "datepickers-container-div"
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      flexDirection: "column"
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "fromto-datepicker-title-web"
  }, "From"), /*#__PURE__*/_react.default.createElement("div", {
    className: "service-logs-date-picker",
    "data-testid": "date-picker-from-web"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("img", {
    src: _images.default.calendar.default,
    alt: "",
    className: "calendar-icon"
  })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactDatepicker.default, {
    placeholderText: "MM/DD/YYYY",
    className: "date-picker-web-from",
    selected: fromValue,
    onChange: date => fromDateChange(date),
    maxDate: toValue
  })))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      flexDirection: "column"
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "fromto-datepicker-title-web"
  }, "To"), /*#__PURE__*/_react.default.createElement("div", {
    className: "service-logs-date-picker",
    "data-testid": "date-picker-to-web"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("img", {
    src: _images.default.calendar.default,
    alt: "",
    className: "calendar-icon"
  })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactDatepicker.default, {
    placeholderText: "MM/DD/YYYY",
    className: "date-picker-web-from",
    selected: toValue,
    onChange: date => toDateChange(date),
    minDate: fromValue
  })))))), /*#__PURE__*/_react.default.createElement("div", null, !isDesktop && /*#__PURE__*/_react.default.createElement("div", {
    className: "datepicker-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "label-style-service-logs"
  }, inputLabelFrom), /*#__PURE__*/_react.default.createElement("div", {
    className: "service-log-date-picker-mobile",
    "data-testid": "from-date-picker"
  }, /*#__PURE__*/_react.default.createElement(_reactDatepicker.default, {
    placeholderText: "Select",
    className: "date-picker-mobile-from",
    selected: fromValue,
    onChange: date => fromDateChange(date),
    maxDate: toValue
  }), /*#__PURE__*/_react.default.createElement("img", {
    src: _images.default.Union.default,
    alt: "",
    className: "calendar-icon-mobile"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "label-style-service-logs"
  }, inputLabelTo), /*#__PURE__*/_react.default.createElement("div", {
    className: "service-log-date-picker-mobile",
    "data-testid": "to-date-picker"
  }, /*#__PURE__*/_react.default.createElement(_reactDatepicker.default, {
    placeholderText: "Select",
    className: "date-picker-mobile-from",
    selected: toValue,
    onChange: date => toDateChange(date),
    minDate: fromValue
  }), /*#__PURE__*/_react.default.createElement("img", {
    src: _images.default.Union.default,
    alt: "",
    className: "calendar-icon-mobile"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "breakLine"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "checkboxes-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "select-services-label"
  }, checkBoxesLabel), servicesLabel === null || servicesLabel === void 0 ? void 0 : servicesLabel.map((item, index, arr) => /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginTop: "20px",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      marginBottom: "20px"
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "checkbox-item"
  }, /*#__PURE__*/_react.default.createElement(_Checkbox.Checkbox, {
    checked: item === null || item === void 0 ? void 0 : item.isChecked,
    onChange: () => onChangeCheckBox(index)
  })), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      marginLeft: "10px",
      fontSize: 16,
      color: "#333333",
      fontWeight: 400,
      ...item.textStyle,
      ...(isDesktop && {
        fontWeight: 600
      })
    },
    variant: "simple-text",
    headerText: item === null || item === void 0 ? void 0 : item.title
  }))), index + 1 < arr.length && /*#__PURE__*/_react.default.createElement("div", {
    className: "breakLine"
  })))))))), ((selectedChipsList === null || selectedChipsList === void 0 ? void 0 : selectedChipsList.length) > 0 || !!fromValue && !!toValue) && /*#__PURE__*/_react.default.createElement("div", {
    className: "chips-container-parent-div"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "chips-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "chip-container-label"
  }, chipContainerLabel), !!fromValue && !!toValue && /*#__PURE__*/_react.default.createElement(_material.Chip, {
    sx: {
      '& .MuiChip-label': [{
        fontSize: "13px",
        fontWeight: "600"
      }]
    },
    style: {
      marginTop: 10,
      marginRight: 5,
      marginLeft: 5
    },
    label: "".concat(fromDateFormatted, " - ").concat(toDateFormatted),
    variant: "outlined",
    deleteIcon: /*#__PURE__*/_react.default.createElement("img", {
      "data-testid": "date-chip-cancel-image",
      src: _images.cancelImg.default
    }),
    onDelete: () => onDeleteChip("date")
  }), selectedChipsList.map((item, index) => {
    if (item.isChecked && index != 0) return /*#__PURE__*/_react.default.createElement(_material.Chip, {
      sx: {
        '& .MuiChip-label': [{
          fontSize: "13px",
          fontWeight: "600"
        }]
      },
      style: {
        marginTop: 10,
        marginRight: 5,
        marginLeft: 5
      },
      label: item.title,
      variant: "outlined",
      deleteIcon: /*#__PURE__*/_react.default.createElement("img", {
        "data-testid": "chip-cancel-image",
        src: _images.cancelImg.default
      }),
      onDelete: () => onDeleteChip(index)
    });
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "breakLine"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "container-style"
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "title-text"
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      margin: 20
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      margin: 0,
      width: "100%",
      display: "flex",
      flexDirection: 'row',
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 27
    },
    variant: "header-text",
    headerText: headerText
  }), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "row"
    },
    "data-testid": "filter-button",
    onClick: handleModal
  }, /*#__PURE__*/_react.default.createElement("img", {
    style: {
      width: 16,
      height: 14,
      alignSelf: "center",
      cursor: "pointer"
    },
    src: _images.default.filterIcon.default,
    alt: "filter"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "filter-text"
  }, "Filter"))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginBottom: 20
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "system-name"
  }, /*#__PURE__*/_react.default.createElement("span", null, systemName)), /*#__PURE__*/_react.default.createElement("div", {
    className: "system-part-number"
  }, /*#__PURE__*/_react.default.createElement("span", null, systemPartNumber)))), Object === null || Object === void 0 ? void 0 : (_Object$keys = Object.keys(listItem)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.map(key => /*#__PURE__*/_react.default.createElement("div", {
    key: key
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "date",
    key: key
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "sub-text",
    headerText: fetchDate(key),
    headerStyle: {
      fontFamily: "Poppins",
      fontSize: "18px",
      fontWeight: 600,
      lineHeight: "27px",
      letterSpacing: "0px",
      textAlign: "left"
    }
  })), (0, _helper.sortObj)((0, _helper.groupByDate)(listItem[key])).map((group, groupIndex) => /*#__PURE__*/_react.default.createElement("div", {
    className: "operation-tile",
    key: groupIndex
  }, Object.keys(group).map(item => /*#__PURE__*/_react.default.createElement(_StoreInformationTile.StoreInformationTile, {
    name: group[item].length > 1 ? "".concat(_strings.serviceLogType[group[item][0].serviceLogsType] + " (" + "".concat(group[item].length) + ")") : _strings.serviceLogType[group[item][0].serviceLogsType],
    onClick: () => operationClicked(group, item),
    "data-testid": "operation-click",
    arrowImage: arrowIcon,
    rightButtonShow: true
  }))))))), loadVisible ? /*#__PURE__*/_react.default.createElement("div", {
    className: "load-more"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "outline-primary-long",
    title: loadMoreButton,
    onClick: onClickLoadMore
  })) : null));
};
var _default = exports.default = ServiceLogsComponent;